const TOWNS = [
  ["Napoli", 40.851, 14.257], ["Pompei", 40.749, 14.485], ["Ercolano", 40.806, 14.348], ["Caserta", 41.073, 14.327],
  ["Paestum", 40.42, 15.005], ["Positano", 40.628, 14.485], ["Ravello", 40.649, 14.611], ["Sorrento", 40.626, 14.376],
  ["Vesuvio", 40.79, 14.43], ["Agerola", 40.633, 14.548], ["Amalfi", 40.634, 14.602], ["Salerno", 40.68, 14.76],
  ["Avellino", 40.91, 14.79], ["Benevento", 41.13, 14.78], ["Cilento", 40.3, 15.05], ["Pozzuoli", 40.823, 14.12],
];

export const nearestTown = (lat, lng) => {
  if (typeof lat !== "number" || typeof lng !== "number") return "Campania";
  let best = "Campania", bd = Infinity;
  TOWNS.forEach(([n, a, b]) => { const d = (a - lat) ** 2 + (b - lng) ** 2; if (d < bd) { bd = d; best = n; } });
  return best;
};
